module.exports = __webpack_public_path__ + "static/resume_builder-f11a13b4d4de18e10ad139fa8344c8f3.png";